import { ProbationTargetSnapshot } from '@/components/Approval/@components/ProbationEvaluation';
import { parseProbationEvaluation } from '@/utils/approval/probationEvaluation';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 188 수습평가서 — 저장 content 그대로(레거시 조회와 동일, 대상자 재조회 없음) */
const ProbationEvaluationSlot = ({ data }: ContentExtraProps) => {
  const state = parseProbationEvaluation(data.attributes);
  if (!state) return null;
  return (
    <ContentSlotRoot>
      <ProbationTargetSnapshot content={state.content} />
    </ContentSlotRoot>
  );
};

export default ProbationEvaluationSlot;
